import { css } from '@emotion/react';
import { Type } from '@robinhood/design';
import { AddressParts } from '@x1/util-format';

import { AddressType } from 'src/clients/Network/gql/types/address';
import Button from 'src/components/creditApplication/Button';
import Cell from 'src/components/creditApplication/Cell';
import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';

interface PropsIface {
  suggestedAddress: AddressType;
  onAccept: () => void;
  onReject: () => void;
  loading: boolean;
}

const AddressSuggestionPage = ({ suggestedAddress, onAccept, onReject, loading }: PropsIface) => {
  const addressParts = AddressParts(suggestedAddress);
  return (
    <CreditApplicationPageLayout title='Suggested address' subtitle='Consider using this formatted address:'>
      <div css={root}>
        <Cell>
          <div css={addressContainer}>
            <Type.Text size='M' isBold>
              {addressParts.addressLine1}
            </Type.Text>
            <Type.Text size='M'>{addressParts.addressLine2}</Type.Text>
          </div>
        </Cell>
        <div css={buttonContainer}>
          <Button
            label='Accept suggested address'
            type='button'
            width='full'
            onClick={onAccept}
            state={loading ? 'loading' : false}
          />
          <Button
            label='Keep address you entered'
            type='button'
            width='full'
            onClick={onReject}
            variant='secondary'
            state={loading ? 'loading' : false}
          />
        </div>
      </div>
    </CreditApplicationPageLayout>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 40px;
`;

const addressContainer = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const buttonContainer = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default AddressSuggestionPage;
